<template>
  <div class="container">
    <p>
      <strong>{{ t('ampCalcImportantNote') }}</strong>
      {{ t('wattageExplanation') }}
    </p>
    <p>{{ t('monthAssumption') }}</p>
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('singleLightWattage')"
          v-model.number="watts"
          :unit="t('watts')"
        />
        <FixedUnitInput
          :input-label="t('voltage')"
          v-model.number="voltage"
          :unit="t('volts')"
        />
        <FixedUnitInput
          :input-label="t('dollarCostPerKWh')"
          v-model.number="kWhCost"
          :unit="t('dollars')"
        />
        <FixedUnitInput
          :input-label="t('hoursOnPerDay')"
          v-model.number="hoursOnPerDay"
          :unit="t('hours')"
        />
        <FixedUnitInput
          :input-label="t('lightCount')"
          v-model.number="lightCount"
          :unit="t('lights')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('totalAmperage')"
          :number="totalAmperage"
          :unit="t('amps')"
        />
        <FixedUnitOutput
          :output-label="t('powerPerDay')"
          :number="kWhPerDay"
          :unit="t('kWhPerDay')"
        />
        <FixedUnitOutput
          :output-label="t('costPerDay')"
          :number="costPerDay"
          unit=""
          :prefix="t('dollarSign')"
        />
        <FixedUnitOutput
          :output-label="t('powerPerMonth')"
          :number="powerPerMonth"
          :unit="t('kWhPerMonth')"
        />
        <FixedUnitOutput
          :output-label="t('costPerMonth')"
          :number="costPerMonth"
          unit=""
          :prefix="t('dollarSign')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import { defaultRound, round } from '../../utils/math';
    import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
      EquationBlock,
    },
    setup() {
      const watts = ref(700);
      const voltage = ref(120);
      const kWhCost = ref(0.12);
      const hoursOnPerDay = ref(12);
      const lightCount = ref(1);


      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('lightingEquations');
      })



      
  
      const totalAmperage = computed(() => {
        return defaultRound(watts.value / voltage.value * lightCount.value);
      });
  
      const kWhPerDay = computed(() => {
        return defaultRound(watts.value * hoursOnPerDay.value * lightCount.value / 1000);
      });
  
      const costPerDay = computed(() => {
        return round(kWhPerDay.value * kWhCost.value, 2);
      });
  
      const powerPerMonth = computed(() => {
        return defaultRound(kWhPerDay.value * 31);
      });
  
      const costPerMonth = computed(() => {
        return defaultRound(costPerDay.value * 31);
      });
  
      return {
        watts,
        voltage,
        kWhCost,
        hoursOnPerDay,
        lightCount,
        totalAmperage,
        kWhPerDay,
        costPerDay,
        powerPerMonth,
        costPerMonth,
        equations,
        t: translations.t
      };
    },
  };
  </script>
  